// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeInboxListBody = {
  category?: "invite" | "pools" | "games" | "chat" | null;
  cursor?: string | null;
  limit?: number | null;
};

export type typeInboxListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      inboxItemId: string;
      alertKind: string;
      group: "invite" | "pools" | "games" | "chat";
      title: string;
      body: string;
      isRead: boolean;
      createdAtIso: string;
      deepLink: {
        kind:
          | "pool"
          | "invite"
          | "game"
          | "chat"
          | "team"
          | "stripCard"
          | "followers";
        poolId?: string | null;
        inviteId?: string | null;
        eventId?: string | null;
        chatId?: string | null;
        teamId?: string | null;
        roundId?: string | null;
        tab?:
          | "matchup"
          | "summary"
          | "lineup"
          | "injuries"
          | "odds"
          | "boxScore"
          | "plays"
          | null;
      };
      poolName: string | null;
    }[];
    nextCursor?: string | null;
  };
};

export type typeInboxListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInboxListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInboxListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaInboxListBody = {
  type: "object",
  properties: {
    category: {
      oneOf: [
        { type: "string", enum: ["invite", "pools", "games", "chat"] },
        { enum: [null] },
      ],
    },
    cursor: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    limit: { oneOf: [{ type: "integer" }, { enum: [null] }] },
  },
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createInboxList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaInboxListBody);
  }

  return async function postInboxList(
    payload: typeInboxListBody,
  ): Promise<typeInboxListOutput200 | typeInboxListOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postInboxList" failed before calling the network. #b830e8784fbe`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#b830e8784fbe" },
        },
        data: null,
      } as typeInboxListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/inbox/list`,
      httpMethod: "POST",
      options,
    })) as typeInboxListOutput200 | typeInboxListOutput400;
  };
}
